const inscripcion = {
  createInscripcionManual: 'inscripcion/{{uuid_academia}}/manual',
  createInscripcionNodoActivoTarea: 'inscripcion/{{uuid_inscripcion}}/nodo-activo-tarea',
  createInscripcionNodoActivoTareaMensaje: 'inscripcion/{{uuid_inscripcion}}/tarea-mensaje',
  readInscripcionActivaByProyectoAlumno: 'inscripcion/{{uuid_proyecto}}',
  readInscripcionesAlumno: 'inscripciones/{{uuid_academia}}/alumno',
  readInscripcionesProyecto: 'inscripciones/{{uuid_proyecto}}',
  readInscripcionesProyectoExportar: 'inscripciones/{{uuid_proyecto}}/exportar',
  readInscripcionNodos: '{{uuid_inscripcion}}/nodos_activos',
  readInscripcionNodoActivoTareaMensajes: 'inscripcion/{{uuid_inscripcion}}/tareas-mensajes',
  readInscripcionNodoActivoTareas: 'inscripcion/{{uuid_inscripcion}}/nodos-activos-tareas',
  updateInscripcionEstado: 'inscripcion/{{uuid_academia}}/estado',
  updateInscripcionNodoEstado: 'inscripcion/{{uuid_academia}}/{{uuid_inscripcion}}/{{uuid_nodo}}',
  updateInscripcionNodoEstadoActivoTarea: 'inscripcion/{{uuid_inscripcion}}/nodo-activo-tarea-estado'
}

export default inscripcion
